var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('InlineSvg',{class:{ colored: _vm.colored },style:(_vm.style),attrs:{"src":require(("../assets/img/svg/" + _vm.name + ".svg")),"title":_vm.title}})}
var staticRenderFns = []

export { render, staticRenderFns }